<div id="ken-dialog__container" kendoDialogContainer>
    <router-outlet></router-outlet>
</div>
<dialog id="loader-wrapper" #loaderWrapper>
    <section id="loader-inner">
        <kendo-loader type="infinite-spinner"></kendo-loader>
        <span>{{loaderMsg()}}</span>
    </section>
</dialog>

<dialog id="prompt-wrapper" #promptWrapper>
    <section id="prompt-inner">
        <h4 class="prompt-title">{{promptOptions()?.title}}</h4>
        <input #promptInput [value]="promptOptions()?.message ?? ''" kendoTextBox type="text" placeholder="{{promptOptions()?.placeholderText}}" />
        <button (click)="onPromptActionBtnClick(promptInput, 'ok')" kendoButton themeColor="primary">{{promptOptions()?.okButtonText}}</button>
        <button (click)="onPromptActionBtnClick(promptInput, 'cancel')" kendoButton>{{promptOptions()?.cancelButtonText}}</button>
    </section>
</dialog>